import { checkDropboxPath } from "./dropboxRequests"
import { simpleUploadImage } from "./networkRequests"
import { ProgressElement } from "../components/revised_components/progressElement"

export class PhotoUploadManager {
  constructor() {
    this.queue = []
    this.executing = false
    this.executionUploadCount = 0
    this.executionErrorCount = 0
  }
  addToQueue(queueItems) {
    this.queue = [...this.queue, ...queueItems]
  }

  updateProgress(progress) {
    let denominator = this.executionUploadCount + this.executionErrorCount + this.queue.length
    let numerator = denominator - this.queue.length
    progress(
      ProgressElement(numerator, denominator, `Uploading Images to Dropbox: (${numerator} / ${denominator})`)
    )
  }

  async executeQueue(progress, userToken) {
    if (this.executing) {
      return false
    }
    this.executing = true

    while (this.queue.length) {
      let { file, dropbox_path } = this.queue.shift()
      // let [localFileExists, localFileLocationError] = await tryCatch(() => checkIfExists(file_path))
      // console.log('PhotoUploadManager: got local file status', file_path, localFileExists)
      // if (localFileLocationError) {
      //   console.warn('PhotoUploadManager: local file doesnt exist, skipping...', file_path)
      //   this.executionErrorCount++
      //   this.updateProgress(progress)
      //   continue
      // }

      let dropboxFileExists = await checkDropboxPath(dropbox_path, userToken)
      // sleep(500)
      console.log('PhotoUploadManager: got dropbox file status', dropbox_path, dropboxFileExists)
      if (dropboxFileExists) {
        console.warn('PhotoUploadManager: Dropbox file exists, skipping...', dropbox_path)
        this.executionErrorCount++
        this.updateProgress(progress)
        continue
      }

      // let [fileBlob, fileReadError] = await tryCatch(async () => await getFileAsBlob(file_path))
      console.log('PhotoUploadManager: got fileblob', file)
      // if (fileReadError) {
      //   console.warn('PhotoUploadManager: Error reading file from disk.', file_path, fileReadError)
      //   this.executionErrorCount++
      //   this.updateProgress(progress)
      //   continue
      // }
      // let buff = await fileBlob.arrayBuffer()
      // buff = Buffer.from(buff)
      // console.log('got buff?', buff)
      // let text = await fileBlob.text()
      // console.log('made text', text)
      console.log('uploading image with permission?', userToken)
      let res = await simpleUploadImage(dropbox_path, file, userToken)
      // let res = await uploadDropboxFile(fileBlob, dropbox_path)
      // console.log('PhotoUploadManager: ')
      console.log('PhotoUploadManager: Uploaded file to dropbox with res:', res)

      this.executionUploadCount++
      this.updateProgress(progress)
    }

    let totalAttempted = this.executionErrorCount + this.executionUploadCount
    progress(ProgressElement(
      1,
      1, 
      'Uploading complete! '+ 
      totalAttempted+ 
      ' photos attempted, '+ 
      this.executionUploadCount+ 
      ' successful, and '+ 
      this.executionErrorCount+ 
      ' errors.'
    ))

    this.executing = false
    this.executionUploadCount = 0
    this.executionErrorCount = 0
    setTimeout(()=>progress(''), 10000)
  }
}

async function tryCatch(fn, error_callback) {
  try {
    let res = await fn()
    return [res, null]
  } catch (error) {
    return [null, error]
  }
}

